export const boxShadow = "rgb(0 0 0 / 16%) 0px 5px 15px 0px";
